import Session from "@lib/session";
import Booking from "./Booking";
import Edit from "./Edit";

function TopBar({ className = "" }: { className?: string }) {
  const isEdit = Session.getBooking().edit;
  return isEdit ? <Edit className={className} /> : <Booking className={className} />;
}

export default TopBar;
